<div class="tutor-assistant">
    <!-- Badge de contexto -->
    <div class="tutor-assistant__context-badge" *ngIf="context">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
            <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
        </svg>
        <span>{{ context.sectionTitle || context.contentTitle }}</span>
    </div>

    <!-- Un único contenedor con scroll: mensajes + sugerencias inline -->
    <div class="tutor-assistant__content" #contentContainer>

        <!-- Mensajes -->
        <ng-container *ngFor="let msg of messages">
            <div
                class="tutor-assistant__message"
                [class.user]="msg.role === 'user'"
            >
                <div class="tutor-assistant__avatar" [class.user]="msg.role === 'user'">
                    <svg *ngIf="msg.role !== 'user'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="M12 8v4l3 3"></path>
                    </svg>
                    <svg *ngIf="msg.role === 'user'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                        <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                </div>
                <div
                    class="tutor-assistant__bubble"
                    [class.user]="msg.role === 'user'"
                    [innerHTML]="msg.content"
                ></div>
            </div>
        </ng-container>

        <!-- Sugerencias iniciales (cargando) -->
        <div *ngIf="isLoadingSuggestions" class="tutor-assistant__inline-loading">
            <span class="spinner-small"></span>
            <span>{{ 'chat.tutor.loading-suggestions' | translate }}</span>
        </div>

        <!-- Sugerencias inline al final del hilo -->
        <div
            *ngIf="suggestedQuestions.length > 0 && !isLoading && !isLoadingSuggestions"
            class="tutor-assistant__inline-suggestions"
        >
            <button
                *ngFor="let q of suggestedQuestions"
                class="tutor-assistant__question-chip"
                [class.static]="q.isStatic"
                (click)="onQuestionSelected(q)"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                    <line x1="12" y1="17" x2="12.01" y2="17"></line>
                </svg>
                <span [innerHTML]="q.text"></span>
            </button>
        </div>

        <!-- Dots de typing mientras responde -->
        <div *ngIf="isLoading" class="tutor-assistant__loader">
            <div class="typing-dots">
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>

    </div>
</div>
